import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import EmojiObjectsIcon from 'components/material-symbol/icons/EmojiObjects'
import TipWell from 'components/tip-well'
import { redirectToLogin, redirectToSignup, useAuth } from 'lib/auth'

const SignInLinks = () => (
  <>
    <Box display="inline" fontWeight={700}>
      <Link
        component="span"
        onClick={() => redirectToLogin('consumer')}
        style={{ cursor: 'pointer' }}
      >
        Login
      </Link>
    </Box>
    {' or '}
    <Box display="inline" fontWeight={700}>
      <Link
        component="span"
        onClick={() => redirectToSignup('consumer')}
        style={{ cursor: 'pointer' }}
      >
        Create
      </Link>
    </Box>
    {' a MyPGA account for a faster registration experience'}
  </>
)

// `callout` renders the nudge as a shared TipWell (used by the redesigned
// registration flow); the default keeps the legacy plain caption. The callout
// is neutral so the host can theme it via `className` / `iconClassName`.
const SignInNudge = ({ callout = false, className, iconClassName }) => {
  const { isLoggedIn } = useAuth()

  if (isLoggedIn) {
    return null
  }

  if (callout) {
    return (
      <TipWell
        variant="neutral"
        icon={EmojiObjectsIcon}
        caption={<SignInLinks />}
        className={className}
        iconClassName={iconClassName}
      />
    )
  }

  return (
    <Box color="text.secondary" mb={1}>
      <Typography variant="caption">
        <SignInLinks />
      </Typography>
    </Box>
  )
}

SignInNudge.propTypes = {
  callout: PropTypes.bool,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
}

export default SignInNudge
